import { ComponentStyleConfig, defineStyleConfig } from '@chakra-ui/react';

const config: ComponentStyleConfig = {
  baseStyle: {
    boxShadow: 'none',
  },
};

export const Tooltip = defineStyleConfig(config);
